import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DatePicker, Select } from "antd";
import { CSVLink } from "react-csv";
import { MDBDataTable } from "mdbreact";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";

import Loading from "../Loading";
import { dateFormat, timeFormat } from "../../../../dynamicController";

const { RangePicker } = DatePicker;
const mySwal = withReactContent(Swal);

const UniqueVoucherCodeReportCard = ({ role, token, operators, distributors }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [campaignOption, setCampaignOption] = useState([]);
    const [campaignFilter, setCampaignFilter] = useState([]);
    const [operatorId, setOperatorId] = useState(null)
    const [distributorId, setDistributorId] = useState(null)
    const [operatorOption, setOperatorOpion] = useState([])
    const [distributorOption, setDistributorOption] = useState([])

    useEffect(() => {
        if (operators) {
            let operatorList = []
            for (let i = 0; i < operators.length; i++) {
                let operatorObject = {
                    value: operators[i].id,
                    label: operators[i].username
                }
                operatorList.push(operatorObject)
            }
            setOperatorOpion(operatorList)
        }
    }, [operators])

    useEffect(() => {
        if (distributors) {
            let distributorList = []
            for (let i = 0; i < distributors.length; i++) {
                let distributorObject = {
                    value: distributors[i].id,
                    label: distributors[i].name
                }
                distributorList.push(distributorObject)
            }
            setDistributorOption(distributorList)
        }
    }, [distributors])

    useEffect(() => {
        if (role !== "client") {
            setLoading(true);
            axios
                .post("/api/admin/report/voucherCodeReport", { distributorId, operatorId, startDate, endDate, campaignFilter }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then((res) => {
                    setData(res.data.data);
                    setCampaignOption(res.data.campaign);
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    }, []);

    const handleDate = (dates, dateStrings) => {
        if (dates) {
            setStartDate(dateStrings[0]);
            setEndDate(dateStrings[1]);
        } else {
            setStartDate("");
            setEndDate("");
        }
    };

    const handleFilter = () => {
        setLoading(true);
        axios
            .post("/api/admin/report/voucherCodeReport", { distributorId, operatorId, startDate, endDate, campaignFilter }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then((res) => {
                setData(res.data.data);
                setCampaignOption(res.data.campaign);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                mySwal.fire(t("Error"), t(err.response.data.error), "error");
            });
    };

    const handleReset = () => {
        setStartDate("");
        setEndDate("");
        setCampaignFilter([]);
        setCampaignOption([])
        setOperatorId(null)
        setDistributorId(null)
        setData([])
        if (role !== "client") {
            setLoading(true);
            axios
                .post("/api/admin/report/voucherCodeReport", {}, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then((res) => {
                    setData(res.data.data);
                    setCampaignOption(res.data.campaign);
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    };

    const handleChangeDistributor = (value) => {
        setDistributorId(value)
        setOperatorId(null)
    }

    const handleChangeOperator = (value) => {
        setOperatorId(value)
        setDistributorId(null)
    }

    const tableData = {
        columns: [
            { label: t("Redemption Date"), field: "redemptionDate", sort: "asc" },
            { label: t("Name"), field: "description", sort: "asc" },
            { label: t("Redemption Code"), field: "redemptionCode", sort: "asc" },
            { label: t("Member ID"), field: "memberId", sort: "asc" },
            { label: t("User Name"), field: "name", sort: "asc" },
            { label: t("Phone Number"), field: "phoneNumber", sort: "asc" },
            { label: t("Email"), field: "email", sort: "asc" },
        ],
        rows: data,
    };

    const csvData = {
        headers: [
            { label: t("Redemption Date"), key: "redemptionDate" },
            { label: t("Name"), key: "description" },
            { label: t("Redemption Code"), key: "redemptionCode" },
            { label: t("Member ID"), key: "memberId" },
            { label: t("User Name"), key: "name" },
            { label: t("Phone Number"), key: "phoneNumber" },
            { label: t("Email"), key: "email" }
        ],
        data: data.map(item => ({
            ...item,
            phoneNumber: `=""${item.phoneNumber}""`,
        }))
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <h5 className="card-title">{t("Unique Voucher Code Report")}</h5>
            </div>

            <div className="card-body">
                <div className="mb-5">
                    <h6>{t("Filter")}</h6>
                    {
                        role === "client" ? (
                            <div className="mb-3">
                                <label htmlFor="distributorId">{t("Select Distributor")}: </label>
                                <Select
                                    id="distributorId"
                                    name="distributorId"
                                    allowClear
                                    style={{ width: '100%' }}
                                    placeholder={t("Select Distributor")}
                                    showSearch
                                    optionFilterProp="label"
                                    onChange={(value) => handleChangeDistributor(value)}
                                    options={distributorOption}
                                    value={distributorId}
                                />
                            </div>
                        ) : null
                    }

                    {
                        role === "client" ? (
                            <div className="mb-3">
                                <label htmlFor="operatorId">{t("Select Operator")}: </label>
                                <Select
                                    id="operatorId"
                                    name="operatorId"
                                    allowClear
                                    style={{ width: '100%' }}
                                    placeholder={t("Select Operator")}
                                    showSearch
                                    optionFilterProp="label"
                                    onChange={(value) => handleChangeOperator(value)}
                                    options={operatorOption}
                                    value={operatorId}
                                />
                            </div>
                        ) : null
                    }

                    <div className="mb-3">
                        <label>{t("Select Name")}: </label>
                        <Select
                            mode="multiple"
                            allowClear
                            style={{ width: "100%" }}
                            placeholder={t("Select Name")}
                            showSearch
                            optionFilterProp="label"
                            value={campaignFilter}
                            onChange={(value) => setCampaignFilter(value)}
                            options={campaignOption.map((item) => ({ label: item.description, value: item.id }))}
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="date">{t("Select Redemption Date")}: </label>
                        <RangePicker
                            id="date"
                            name="date"
                            placeholder={[t("Start date"), t("End date")]}
                            onChange={handleDate}
                            style={{ width: '100%' }}
                            value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : []}
                            presets={[
                                { label: t("Today"), value: [dayjs(), dayjs()] },
                                { label: t("Yesterday"), value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')] },
                                { label: t("Last 7 Days"), value: [dayjs().subtract(6, 'day'), dayjs()] },
                                { label: t("Last 30 Days"), value: [dayjs().subtract(29, 'day'), dayjs()] },
                                { label: t("This Month"), value: [dayjs().startOf('month'), dayjs().endOf('month')] },
                                { label: t("Last Month"), value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] }
                            ]}
                        />
                    </div>

                    <div className="d-flex">
                        <button onClick={() => handleFilter()} className="btn btn-primary btn-inline form-control me-3">
                            {t("Filter")}
                        </button>
                        <button onClick={() => handleReset()} className="btn btn-secondary btn-inline form-control ms-3">
                            {t("Reset")}
                        </button>
                    </div>
                </div>

                <div className="text-center mt-5">
                    {
                        loading ? (
                            <Loading />
                        ) : (
                            <div>
                                <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename={`unique_vouchercode_report_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank"       >
                                        {t("Download Report")}
                                    </CSVLink>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default UniqueVoucherCodeReportCard;